<!-- <div class="transition duration-300 overflow-hidden h-0" [ngClass]="{'h-52': expandir_contraer}"> -->
  <div
    class="p-3 flex items-center border-b-2 border-gray-400 last:border-0"
    [ngClass]="customClass ? customClass : ''"
    (click)="selectionItem()"
  >
    <ion-icon *ngIf="multiple" [name]="isSelected ? 'checkbox' : 'square-outline'"
      [color]="isSelected ? 'secondary' : null"
      class="text-xl mr-2 shrink-0"
    ></ion-icon>
    <ng-content></ng-content>
  </div>

<!-- </div> -->